// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

// Google Maps Configuration
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Other Configuration
export const MAX_ADDRESSES = 2;
export const DEFAULT_DELIVERY_RADIUS = 10; // in kilometers
export const ITEMS_PER_PAGE = 12;
